import { Checkbox, TableCell, TableRow, styled } from '@mui/material';
import ReviewStatus from '~/components/Structures/ReviewStatus';
import { Roi } from '~/domain/dicom/dicomstructureset';

type StructureRowProps = {
    structure: Roi;
    onSelect: (structure: Roi) => void;
    selectedStructures: Roi[];
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
        cursor: 'pointer',
    },
    '&:hover .hover-add-dose': {
        display: 'inline-flex',
    },
}));

const StructureRow = ({
    structure,
    selectedStructures,
    onSelect,
}: StructureRowProps) => {
    return (
        <StyledTableRow onClick={() => onSelect(structure)}>
            <TableCell
                align="left"
                sx={{
                    paddingLeft: 0.5,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                }}
            >
                <Checkbox
                    size="small"
                    checked={selectedStructures.includes(structure)}
                />
                {structure.name}
            </TableCell>
            <TableCell align="left">{structure.interpretedType}</TableCell>
            <TableCell align="right">
                <ReviewStatus
                    status={structure.approvalStatus}
                    boxProps={{ justifyContent: 'end' }}
                    fontSize={12}
                />
            </TableCell>
        </StyledTableRow>
    );
};

export default StructureRow;
